import { HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";

import { Injectable, inject } from "@angular/core";
import { AuthHttpInterceptor, AuthService } from "@auth0/auth0-angular";
import { Observable, throwError } from "rxjs";
import { Auth0AuthenticationService } from "src/app/core/auth0-authentication.service";
import { HttpClient } from "@angular/common/http";
import { catchError, switchMap } from "rxjs/operators";

@Injectable()
export class AuthInterceptor extends AuthHttpInterceptor {
  private auth = inject(AuthService);

  override intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let location = window.location;

    if (req.url.includes('bookingwidget') || 
        req.url.includes('digitalwaiverwidget') || 
        req.url.includes('bookingmembershipwidget') ||
        req.url.includes('membershipcustomerwidget') ||
        req.url.includes('registrationwidget') ||
        req.url.includes('leagueiterationmember/checkoutsession')) {
      return next.handle(req);
    }

    if (location.pathname.includes("signup") && req.url.includes('signup') || 
    location.pathname.includes("signup") && req.url.includes('identityuser/create') || 
    location.pathname.includes("signup") && req.url.includes("stripe") ||
    location.pathname.includes("booking-widget") && req.url.includes("promocode")) {
      let auth0AuthenticationService = new Auth0AuthenticationService(new HttpClient(next));
      
      return auth0AuthenticationService.getToken().pipe(
        switchMap((res: any) => {
          const clonedRequest = req.clone({
            setHeaders: {
              Authorization: `${res.token_type} ${res.access_token}`,
              'Content-Type': 'application/json'
            }
          });
          return next.handle(clonedRequest);
        }),
        catchError(err => {
          console.error('AuthInterceptor error:', err);
          return throwError(() => err);
        })
      );
    }else{
      return super.intercept(req, next);
    }
  }
}